import axios from 'axios';
import store from '@/store';

const urlPath = '/dps/plan'

export default {
  apiUrl: function () {
    return store.state.apiSelected.apiHost;
  },
  async listByParking(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/listByParking`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback(error)
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/planService.js